export class HospitalPackedParam {
    FacilityId: string;
    CustomerId: string;
    StartDate: Date | null = null;
    EndDate: Date | null = null;    
};


// WEBPACK FOOTER //
// ./src/app/models/HospitalPackedParam.ts